module.exports = __webpack_public_path__ + "static/media/DCXAS.d0fa7d3d.jpg";